<template>
    <div class="Experience">
        <div class="App-container">   
            <Home v-if="$route.meta.name == 'welcome'"/>         
        </div>  
        <Header/> 
        <Alert v-if="alert"/> 
    </div>
</template>

<script>

import gsap from "gsap"
import Home from "@/components/pages/Home"
import Header from "@/components/assets/Header"
import Alert from "@/components/assets/Alert"

export default {

    name: 'Experience',
    components: { Home, Header, Alert },
    computed:{
        alert() { return this.$store.getters['commons/alert'] },
    },
    mounted() {
        const colors = ['orange', 'green', 'blue', 'purple']
        const color = colors[_.random(3)]
        this.$store.commit('commons/SET_TINT', color)
        gsap.delayedCall(1, ()=> this.$store.commit('commons/INITIALIZED'))   
    },

}
</script>

<style lang='stylus'>

@import '~@/commons/stylus/Media-queries'
@import '~@/config/Settings'

.Experience
    position absolute
    width 100%
    height 100%
    text-align center
    display flex
    flex-direction column
    justify-content center
    align-items center

</style>


